import React, { useState } from 'react';
import { Slider, Box, Typography } from '@mui/material';

const CashbackGoalSlider = () => {
  const [value, setValue] = useState(140); // Initial value

  // Calculate points based on the value
  const points = Math.floor((value / 100) * 10); // Assuming each ₹100 corresponds to 10 points

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', padding: '20px', backgroundColor: '#2E1F47', borderRadius: '8px', textAlign: 'center' }}>
      <Typography variant="h6" color="white" sx={{ marginBottom: 2 }}>
        Cashback Goal
      </Typography>

      {/* Points Display */}
      <Box sx={{ marginBottom: 2, color: 'white', fontSize: '18px' }}>
        <Typography variant="h6">Points: {points}</Typography>
      </Box>

      {/* Cashback Goal Slider */}
      <Slider
        value={value}
        onChange={handleSliderChange}
        valueLabelDisplay="auto"
        valueLabelFormat={(value) => `₹${value}`}
        min={100}
        max={1000}
        step={10}
        valueLabelPlacement="top"
        sx={{
          color: '#FFD700',
          '& .MuiSlider-rail': {
            backgroundColor: '#6A4C8C',
            opacity: 0.6,
          },
          '& .MuiSlider-track': {
            backgroundColor: '#FFD700',
          },
          '& .MuiSlider-thumb': {
            backgroundColor: '#FFD700',
            borderRadius: '50%',
            boxShadow: '0 0 10px rgba(255, 215, 0, 0.7)', // Glowing effect for the thumb
          },
          '& .MuiSlider-valueLabel': {
            backgroundColor: 'transparent',
            color: 'white',
            fontWeight: 'bold',
          },
        }}
      />

      {/* Labels and Marks */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', color: 'white', marginTop: 2 }}>
        <Typography variant="body2">₹100</Typography>
        <Typography variant="body2">₹200</Typography>
        <Typography variant="body2">₹1000</Typography>
      </Box>

      {/* Active Segment Highlight */}
      <Box
        sx={{
          height: '6px',
          background: `linear-gradient(90deg, rgba(255, 215, 0, 1) ${((value - 100) / (1000 - 100)) * 100}%, rgba(106, 76, 140, 0.5) ${(value - 100) / (1000 - 100) * 100}%)`,
          marginTop: 2,
          borderRadius: '8px',
        }}
      ></Box>
    </Box>
  );
};

export default CashbackGoalSlider;
